import { useMutation } from "@tanstack/react-query";
import { CreateVenueParams, createVenue } from "supabase/venues";
import { queryClient } from "utils";

export type CreatedVenue = {
  id: number;
  name: string;
  /** The row exists but its picture could not be uploaded or saved. */
  pictureFailed: boolean;
};

export const useCreateVenue = (
  onSuccess: (created: CreatedVenue) => any,
  // 33.3 WR-01: a failed insert (RLS, constraint, network) is reported, not
  // swallowed. The caller owns the copy (this hook has no i18n).
  onError?: (error: unknown) => void
) => {
  const mutation = useMutation({
    mutationFn: (venue: CreateVenueParams) => {
      return createVenue(venue);
    },
    onSuccess: (data) => {
      // Invalidate first: ["venues"] also covers useQueryVenues' paged keys
      queryClient.invalidateQueries({
        queryKey: ["venues"],
      });

      onSuccess({
        id: data.id,
        name: data.name ?? "",
        pictureFailed: data.pictureFailed,
      });
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};
